import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/courses-bulk-update-action-types';

import type {List} from 'immutable';

export type CoursesBulkUpdateStore = {
    ownerUsers: List<unknown>;
};

const initialState = () => {
    return {
        ownerUsers: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.GET_OWNER_USERS_SUCCESS]: (state, action) => {
        return {
            ownerUsers: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<CoursesBulkUpdateStore>(initialState(), actionsMap);
